<template>
  <div style="height: 100%;width: 100%;overflow: hidden;">
    <StandardSearchPageView
      ref="table"
      rowKey="id"
      :columns="getColumns()"
      :enableSearch="false"
      :queryParams="queryParams"
      :operationBoxStyle="{ padding: '0 0 16px' }"
      :requestPromise="loadDataList"
    >
      <a-button slot="operation" type="primary" icon="plus" @click="onAddEvent">新建</a-button>
      <template v-slot:action="{ record }">
        <a-space>
          <a @click="onEditEvent(record)">编辑</a>
          <a @click="onSwitchStatus(record)">{{ record.status == 1 ? '禁用' : '启用' }}</a>
        </a-space>
      </template>
    </StandardSearchPageView>
    <SimpleFormEditorDialog
      v-if="showDialog"
      :editConfigList="editConfigList"
      :item="selectItem"
      :rules="rules"
      :title="selectItem && selectItem.id ? '编辑账号' : '新增账号'"
      @cancel="showDialog = false"
      @ok="onEditResultEvent"
    >
      <template v-slot:interfaceKey="{ form, item }">
        <a-input-password
          v-model="form[item.key]"
          :placeholder="item.placeholder"
          style="width: 100%"
        />
      </template>
    </SimpleFormEditorDialog>
  </div>
</template>

<script>
import SimpleFormEditorDialog from '@/customComponents/SimpleFormEditorDialog.vue'
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'

export default {
  name: 'AssociatedAccountComponent',
  components: {
    SimpleFormEditorDialog,
    StandardSearchPageView
  },
  data () {
    return {
      showDialog: false,
      selectItem: undefined,
      queryParams: {},
      editConfigList: [
        {
          name: '供应商名称',
          key: 'supplierName',
          placeholder: '仅用于区分标识数据来源，6个字以内'
        },
        {
          name: '接口地址',
          key: 'baseUrl',
          placeholder: '请输入接口地址'
        },
        {
          name: '供应商ID(supplierID)',
          key: 'supplierId',
          placeholder: '请输入供应商ID'
        },
        {
          name: '密钥(interfacekey)',
          key: 'interfaceKey',
          placeholder: '请输入密钥',
          slot: true
        }
      ],
      rules: {
        supplierName: [{ required: true, message: '请输入供应商名称', trigger: 'change,blur' }],
        baseUrl: [{ required: true, message: '请输入接口地址', trigger: 'change,blur' }],
        supplierId: [{ required: true, message: '请输入供应商ID', trigger: 'change,blur' }],
        interfaceKey: [{ required: true, message: '请输入密钥', trigger: 'change,blur' }]
      }
    }
  },
  methods: {
    loadDataList (params) {
      const requestParams = {
        ...params,
        ...params.limitDto,
        limitDto:undefined,
        merchantId: this.$store.getters.userInfo.merchantId
      }
      return this.getHttpServices().getSourceService().post('pushXC/accounts/page', requestParams)
    },
    getColumns () {
      return [
        {
          title: '供应商名称',
          dataIndex: 'supplierName',
          width: '200px'
        },
        {
          title: '供应商ID(supplierID)',
          dataIndex: 'supplierId',
          width: '160px'
        },
        {
          title: '接口地址',
          dataIndex: 'baseUrl',
          width: '320px'
        },
        {
          title: '状态',
          dataIndex: 'statusName',
          width: '100px'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '180px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '140px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
    refreshData (reset) {
      this.$refs.table && this.$refs.table.refresh(reset)
    },
    onAddEvent () {
      this.selectItem = undefined
      this.showDialog = true
    },
    onEditEvent (item) {
      const params = {
        id: item.id,
        merchantId: this.$store.getters.userInfo.merchantId
      }
      this.getHttpServices().getSourceService().post('pushXC/accounts/detail', params)
        .then(res => {
          this.selectItem = {
            ...res,
            interfaceKey: res.interfaceKeyMask
          }
          this.showDialog = true
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '获取账号详情失败，请重试！')
          console.error(err)
        })
    },
    onSwitchStatus (item) {
      const params = {
        id: item.id,
        merchantId: this.$store.getters.userInfo.merchantId,
        status: String(item.status) === '1' ? 0 : 1
      }
      this.getHttpServices().getSourceService().post('pushXC/accounts/status', params)
        .then(() => {
          this.$message.success('操作成功！')
          this.refreshData(false)
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '操作失败，请重试！')
          console.error(err)
        })
    },
    onEditResultEvent (params) {
      const isEdit = !!params.id
      const url = isEdit ? 'pushXC/accounts/update' : 'pushXC/accounts/create'
      const requestParams = {
        supplierName: params.supplierName,
        supplierId: Number(params.supplierId),
        merchantId: this.$store.getters.userInfo.merchantId,
        baseUrl: params.baseUrl,
        status: isEdit ? params.status : 1
      }
      if (isEdit) {
        requestParams.id = params.id
      }
      requestParams.interfaceKey = params.interfaceKey
      this.getHttpServices().getSourceService().post(url, requestParams)
        .then(() => {
          this.showDialog = false
          this.selectItem = undefined
          this.$message.success('操作成功！')
          this.refreshData(!isEdit)
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '操作失败，请重试！')
          console.error(err)
        })
    }
  }
}
</script>

<style scoped></style>
